<template>
  <ul class="statistic">
    <li class="statistic__item">
      <BaseProgress
        :height="10"
        :show-percentage="false"
        :value="completedPercent"
      >
        <template v-slot:label>
          {{ $t('completed_lessons') }}: <strong>{{ statistic.completed_lessons }} {{ $t('from') }} {{ statistic.total_lessons }}</strong>
        </template>
      </BaseProgress>
    </li>

    <li class="statistic__item">
      <BaseProgress
        :height="10"
        :show-percentage="false"
        :value="timerPercent"
      >
        <template v-slot:label>
          {{ $t('time_elapsed') }}:

          <strong>
            {{ formatTime(statistic.timer_seconds) }} {{ $t('from') }}

            <!-- общее кол-во часов для прохождения курса -->
            {{ Math.round(statistic.total_timer_seconds / 3600) }} {{ $t('hr') }}
          </strong>
        </template>
      </BaseProgress>
    </li>
  </ul>
</template>

<script>
import progressApi from '@/data/ProgressApi';
import BaseProgress from '@/components/BaseProgress';

export default {
  name: 'CourseStatistic',

  props: {
    course: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      statistic: {
        completed_lessons: 0,
        timer_seconds: 0,
        total_lessons: 1,
        total_timer_seconds: 1,
      }
    }
  },

  created() {
    this.fetchStatistic();
  },

  computed: {
    completedPercent() {
      if (this.statistic.total_lessons > 0 && this.statistic.completed_lessons > 0)
        return Math.round(100 / this.statistic.total_lessons * this.statistic.completed_lessons);
      return 0;
    },
    timerPercent() {
      if (this.statistic.total_timer_seconds > 0 && this.statistic.timer_seconds > 0)
        return Math.round(100 / this.statistic.total_timer_seconds * this.statistic.timer_seconds);
      return 0;
    }
  },

  methods: {
    formatTime(seconds) {
      let hours = Math.floor(seconds / 3600);
      let minutes = Math.floor(seconds % 3600 / 60);
      if (!hours && !minutes) {
        return 0;
      }
      return (hours > 0 ? `${hours} ${this.$t('hr')}` : '') + ' ' + (minutes > 0 ? `${minutes} ${this.$t('min')}` : '');
    },

    fetchStatistic() {
      progressApi.fetchStatisticByCourse(this.course.idcourse)
        .then(statistic => {
          this.statistic = statistic;
        });
    }
  },

  components: {
    BaseProgress,
  }
}
</script>

<style>
.statistic {
  list-style: none;
  margin: 0;
  padding: 0;
}
.statistic__item + .statistic__item {
  margin-top: 10px;
}
.progress-wrapper {
  padding-top: 0;
}
.progress {
  background-color: #e7eff2;
  border-radius: 5px;
  box-shadow: none;
}
.progress-bar.bg-default {
  background-color: #5bb947 !important;
}
.progress-info {
  margin-bottom: 0;
}
.progress-label span {
  background-color: transparent;
  color: inherit;
  font-size: .85rem;
  font-weight: normal;
  padding: 0;
  text-transform: none;
}
.progress-label strong {
  font-family: 'Manrope Bold', 'Open Sans', sans-serif;
}
</style>
